export const generateUniqueKey = (): string => {
    return Math.random().toString(36).slice(-8);
};
